<template>
  <div class="h-12 mb-6 shrink-0 w-12">
    <cx-tooltip v-if="!isSidebarExpanded" placement="right" :distance="30">
      <button
        v-hubble="'toggle-button'"
        class="focus:outline-none focus:ring-red-700 hover:ring-red-700 ring-2 ring-transparent rounded-lg transition-shadow"
        aria-expanded="false"
        :aria-label="$t('expandSideNav')"
        @click="toggleSidebarExpandStatus"
      >
        <app-logo class="h-full hover:ring-red-700 w-full" />
      </button>

      <template #content>
        <div class="flex items-center justify-center space-x-2">
          <p class="text-white">{{ $auth.user.orgName }}</p>
          <org-type-badge :type="$auth.user.org.type" />
        </div>
      </template>
    </cx-tooltip>

    <button
      v-else
      class="bg-gray-600 cursor flex focus:outline-none focus:ring-red-700 h-full hover:ring-red-700 items-center justify-center ring-2 ring-transparent rounded-lg transition-shadow w-full"
      aria-expanded="true"
      :aria-label="$t('collapseSideNav')"
      @click="toggleSidebarExpandStatus"
    >
      <cx-icon name="close-fill" class="text-white" />
    </button>
  </div>
</template>

<script>
import AppLogo from '~/components/common/AppLogo';
import { CxTooltip, CxIcon } from '~/components/cx';
import OrgTypeBadge from '~/components/orgs/OrgTypeBadge';

export default {
  name: 'AppSidebarLogo',

  hubble: 'app-sidebar-logo',

  components: {
    AppLogo,
    CxIcon,
    CxTooltip,
    OrgTypeBadge,
  },

  props: {
    isSidebarExpanded: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    toggleSidebarExpandStatus() {
      this.$emit('toggle-expand');
    },
  },
};
</script>

<i18n lang="json">
{
  "en": {
    "collapseSideNav": "collapse side navigation",
    "expandSideNav": "expand side navigation"
  }
}
</i18n>
